// import React, { useState } from "react";
// import logo from "../../assets/navbar/Group 1000008451 (1) 1.svg";
// import "./Navbar.css"; // Import the CSS file
// import { ImCross } from "react-icons/im";
// import { FaBars } from "react-icons/fa";

// const Navbar = () => {
//   const [active, setActive] = useState(false);
//   const handleClickNav = () => {
//     setActive(!active);
//   };
//   return (
//     <div className="navbar">
//       <div className="navbar-container">
//         <div>
//           <img src={logo} alt="logo" className="logo" />
//         </div>
//         {active ? (
//           <div>
//             <ImCross className="CrossMark" onClick={handleClickNav} />
//           </div>
//         ) : (
//           <div>
//             <FaBars className="CuroselIcon" onClick={handleClickNav} />
//           </div>
//         )}
//         <div className={`navbar-menu ${active ? "show" :""}`}>
//           <ul className="menu-items">
//             <li className="menu-item">Features</li>
//             <li className="menu-item">Solutions</li>
//             <li className="menu-item">Pricing</li>
//             <li className="menu-item">Resources</li>
//             <li className="menu-item">Integrations</li>
//             <li className="menu-item">Support</li>
//           </ul>
//         </div>
//         <div className="navbar-action">
//           <button className="signup-button">Sign-up</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import logo from "../../assets/navbar/Group 1000008451 (1) 1.svg";
import "./Navbar.css"; // Import the CSS file
import { ImCross } from "react-icons/im";
import { FaBars } from "react-icons/fa";
import FeaturesPop from "../../Pages/FeaturesPoP-up/FeaturesPop";
import IntegrationPoP from "../../Pages/Integrations/IntegrationPoP";
import { createPortal } from "react-dom"; // For portal rendering
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [active, setActive] = useState(false);
  const [isShown, setIsShown] = useState("false");
  const navigate = useNavigate();

  // useEffect(()=>{

  // },[isShown])
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClickNav = () => {
    setActive((prev) => !prev);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const menu = document.querySelector(".navbar-menu");
      if (
        menu &&
        !menu.contains(event.target) &&
        event.target.closest(".CuroselIcon") === null
      ) {
        setActive(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  console.log(isShown);
  const navigateHome = () => {
    navigate("/");
  };
const navigatePricing =()=>{
  navigate("/Pricing")
}
  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="navbar_mobile_view">
          <div className="navbar_logo_container">
            <img
              src={logo}
              alt="logo"
              className="logo"
              onClick={navigateHome}
            />
          </div>
          <div className="icons_navbar">
            {active ? (
              <ImCross
                className="CrossMark"
                onClick={handleClickNav}
                aria-label="Close menu"
              />
            ) : (
              <FaBars
                className="CuroselIcon"
                onClick={handleClickNav}
                aria-label="Open menu"
              />
            )}
          </div>
        </div>
        <div className={`navbar-menu ${active ? "show" : ""}`}>
          <ul className="menu-items" onMouseLeave={() => setIsShown(null)}>
            <li
              className="menu-item"
              onMouseEnter={() => setIsShown("Features")}
              onClick={() => handleScroll("layer1")}
            >
              Features
            </li>
            <li className="menu-item" onClick={() => handleScroll("layer2")}>
              Solutions
            </li>
            <li className="menu-item" onClick={navigatePricing}>
              Pricing
            </li>
            <li className="menu-item">Resources</li>
            <li
              className="menu-item"
              onMouseEnter={() => setIsShown("Modules")}
            >
              Modules
            </li>
            <li className="menu-item">Support</li>
          </ul>
          <div className="navbar-action">
            <Link to="https://app.oraddo.com/signup">
              <button className="signup-button">Sign Up</button>
            </Link>
            <Link to="https://app.oraddo.com">
            <button className="login-button">Login</button>
            </Link>
          </div>

          {isShown === "Features" &&
            createPortal(
              <div className="features_page">
                <FeaturesPop />
              </div>,
              document.body // Render the dropdown in the body to prevent clipping
            )}
          {isShown === "Modules" &&
            createPortal(
              <div className="integratinPoP_page">
                <IntegrationPoP />
              </div>,
              document.body // Render the dropdown in the body to prevent clipping
            )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
